import React from 'react';
// import { useNavigate } from 'react-router-dom';
import { Logo } from '@livable/saas-react-components';
// import { Button } from '@mui/material';
import useStyles from './styles';
export default function TextPageWrapper(_ref) {
  let children = _ref.children;
  // const navigate = useNavigate();
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerLogo
  }, /*#__PURE__*/React.createElement(Logo, null))), /*#__PURE__*/React.createElement("div", {
    className: classes.body
  }, children));
}